module.exports = __webpack_public_path__ + "img/A.1704671d.png";